/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import {
  PharmacyCalendar,
  PharmacyCalendarFromJSON,
  PharmacyCalendarFromJSONTyped,
  PharmacyCalendarToJSON,
  PharmacyCurrentInformation,
  PharmacyCurrentInformationFromJSON,
  PharmacyCurrentInformationFromJSONTyped,
  PharmacyCurrentInformationToJSON,
  PharmacyCurrentInformations,
  PharmacyCurrentInformationsFromJSON,
  PharmacyCurrentInformationsFromJSONTyped,
  PharmacyCurrentInformationsToJSON,
  PharmacyDeliveryPostalArea,
  PharmacyDeliveryPostalAreaFromJSON,
  PharmacyDeliveryPostalAreaFromJSONTyped,
  PharmacyDeliveryPostalAreaToJSON,
  PharmacyExternalAIAssistantScope,
  PharmacyExternalAIAssistantScopeFromJSON,
  PharmacyExternalAIAssistantScopeFromJSONTyped,
  PharmacyExternalAIAssistantScopeToJSON,
  PharmacyMeritTags,
  PharmacyMeritTagsFromJSON,
  PharmacyMeritTagsFromJSONTyped,
  PharmacyMeritTagsToJSON,
  PharmacyMobileOrderCallingScreenMessage,
  PharmacyMobileOrderCallingScreenMessageFromJSON,
  PharmacyMobileOrderCallingScreenMessageFromJSONTyped,
  PharmacyMobileOrderCallingScreenMessageToJSON,
  PharmacyOptionalParameter,
  PharmacyOptionalParameterFromJSON,
  PharmacyOptionalParameterFromJSONTyped,
  PharmacyOptionalParameterToJSON,
  PharmacyPaymentMethod,
  PharmacyPaymentMethodFromJSON,
  PharmacyPaymentMethodFromJSONTyped,
  PharmacyPaymentMethodToJSON,
  PharmacyPharmacyCrowdStatusSetting,
  PharmacyPharmacyCrowdStatusSettingFromJSON,
  PharmacyPharmacyCrowdStatusSettingFromJSONTyped,
  PharmacyPharmacyCrowdStatusSettingToJSON,
  PharmacyPharmacyDeliverySettings,
  PharmacyPharmacyDeliverySettingsFromJSON,
  PharmacyPharmacyDeliverySettingsFromJSONTyped,
  PharmacyPharmacyDeliverySettingsToJSON,
  PharmacyPharmacyHours,
  PharmacyPharmacyHoursFromJSON,
  PharmacyPharmacyHoursFromJSONTyped,
  PharmacyPharmacyHoursToJSON,
  PharmacyPharmacyListImage,
  PharmacyPharmacyListImageFromJSON,
  PharmacyPharmacyListImageFromJSONTyped,
  PharmacyPharmacyListImageToJSON,
  PharmacyPharmacyStations,
  PharmacyPharmacyStationsFromJSON,
  PharmacyPharmacyStationsFromJSONTyped,
  PharmacyPharmacyStationsToJSON,
  PharmacyRecurringCalendar,
  PharmacyRecurringCalendarFromJSON,
  PharmacyRecurringCalendarFromJSONTyped,
  PharmacyRecurringCalendarToJSON,
  PharmacyTokushoho,
  PharmacyTokushohoFromJSON,
  PharmacyTokushohoFromJSONTyped,
  PharmacyTokushohoToJSON,
} from "./";

export const PharmacyPharmacyTypename = "PharmacyPharmacy" as const;

/**
 *
 * @export
 * @interface PharmacyPharmacy
 */
export interface PharmacyPharmacy {
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacy
   */
  additionalHoursText?: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacy
   */
  address: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacy
   */
  aiOcrRecognitionMode?: PharmacyPharmacyAiOcrRecognitionModeEnum;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacy
   */
  calendarType: PharmacyPharmacyCalendarTypeEnum;
  /**
   *
   * @type {Array<PharmacyCalendar>}
   * @memberof PharmacyPharmacy
   */
  calendars?: Array<PharmacyCalendar>;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacy
   */
  chainAppName?: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacy
   */
  chainFqdn?: string;
  /**
   *
   * @type {number}
   * @memberof PharmacyPharmacy
   */
  chainId?: number;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  chainIsExceededFollowUpCharLimit?: boolean;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacy
   */
  chainName?: string;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  chainRequiredChildWeight?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  chainRequiredDateOfBirth?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  chainUsableChainFollowUp?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  chainUsableChildWeight?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  chainUsableElapsedTime?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  chainUsableMedicineNotebook?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  chainUsableRefill?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  chainUsableReserverType?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  chainUsableUnsupportedList?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  chainUsableWaitingLabel?: boolean;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacy
   */
  cityCode?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof PharmacyPharmacy
   */
  closedDays: Array<string>;
  /**
   *
   * @type {number}
   * @memberof PharmacyPharmacy
   */
  counselingBoothCount?: number;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacy
   */
  counselingBoothName?: string;
  /**
   *
   * @type {PharmacyPharmacyHours}
   * @memberof PharmacyPharmacy
   */
  counselingReceptionHours?: PharmacyPharmacyHours;
  /**
   *
   * @type {Array<PharmacyRecurringCalendar>}
   * @memberof PharmacyPharmacy
   */
  counselingRecurringCalendars?: Array<PharmacyRecurringCalendar>;
  /**
   *
   * @type {number}
   * @memberof PharmacyPharmacy
   */
  counselingSlotMinutes?: number;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  createTalkroom?: boolean;
  /**
   *
   * @type {PharmacyPharmacyCrowdStatusSetting}
   * @memberof PharmacyPharmacy
   */
  crowdStatusSetting?: PharmacyPharmacyCrowdStatusSetting;
  /**
   *
   * @type {PharmacyCurrentInformation}
   * @memberof PharmacyPharmacy
   */
  currentInformation: PharmacyCurrentInformation;
  /**
   *
   * @type {PharmacyCurrentInformations}
   * @memberof PharmacyPharmacy
   */
  currentInformations: PharmacyCurrentInformations;
  /**
   *
   * @type {Array<PharmacyDeliveryPostalArea>}
   * @memberof PharmacyPharmacy
   */
  deliveryPostalAreas?: Array<PharmacyDeliveryPostalArea>;
  /**
   *
   * @type {PharmacyPharmacyDeliverySettings}
   * @memberof PharmacyPharmacy
   */
  deliverySetting?: PharmacyPharmacyDeliverySettings;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  disableCounselingSlotUnspecified?: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof PharmacyPharmacy
   */
  dispensingCounters?: Array<string>;
  /**
   *
   * @type {PharmacyPharmacyHours}
   * @memberof PharmacyPharmacy
   */
  dispensingReceptionHours?: PharmacyPharmacyHours;
  /**
   *
   * @type {Array<PharmacyRecurringCalendar>}
   * @memberof PharmacyPharmacy
   */
  dispensingRecurringCalendars?: Array<PharmacyRecurringCalendar>;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacy
   */
  email: string;
  /**
   *
   * @type {Array<PharmacyExternalAIAssistantScope>}
   * @memberof PharmacyPharmacy
   */
  externalAiAssistantScope?: Array<PharmacyExternalAIAssistantScope>;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacy
   */
  externalId?: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacy
   */
  fax: string;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  faxPrescriptionWithImage?: boolean;
  /**
   *
   * @type {Array<PharmacyDeliveryPostalArea>}
   * @memberof PharmacyPharmacy
   */
  filteredDeliveryPostalAreas?: Array<PharmacyDeliveryPostalArea>;
  /**
   *
   * @type {number}
   * @memberof PharmacyPharmacy
   */
  groupId?: number;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  hasLineOfficialAccount?: boolean;
  /**
   *
   * @type {number}
   * @memberof PharmacyPharmacy
   */
  id: number;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  ignorePublicHoliday?: boolean;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacy
   */
  institutionCode: string;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  isCounselingReceptionUntilClosing?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  isCredit?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  isDelivery?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  isDispensing?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  isDisplayVisitWithinOneHour?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  isElectronicMoney?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  isFollowUpOnly?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  isMobileOrderQrCodeEnlarged?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  isOnline?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  isOnlinePayment?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  isOpenToday?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  isParking?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  isPrescription?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  isQrPayment?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  isSameDayDelivery?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  isScreening?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  isTell?: boolean;
  /**
   *
   * @type {number}
   * @memberof PharmacyPharmacy
   */
  latitude: number;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacy
   */
  lineInterviewUrl?: string;
  /**
   *
   * @type {Array<PharmacyPharmacyListImage>}
   * @memberof PharmacyPharmacy
   */
  listImage?: Array<PharmacyPharmacyListImage>;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacy
   */
  logoImageUrl?: string;
  /**
   *
   * @type {number}
   * @memberof PharmacyPharmacy
   */
  longitude: number;
  /**
   *
   * @type {PharmacyMeritTags}
   * @memberof PharmacyPharmacy
   */
  meritTag?: PharmacyMeritTags;
  /**
   *
   * @type {number}
   * @memberof PharmacyPharmacy
   */
  minIntegratedCounselingIntervalMinutes?: number;
  /**
   *
   * @type {Array<PharmacyMobileOrderCallingScreenMessage>}
   * @memberof PharmacyPharmacy
   */
  mobileOrderCallingScreenMessages?: Array<PharmacyMobileOrderCallingScreenMessage>;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacy
   */
  mynaHomeWebUrl?: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacy
   */
  name: string;
  /**
   *
   * @type {PharmacyPharmacyStations}
   * @memberof PharmacyPharmacy
   */
  nearestStation: PharmacyPharmacyStations;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacy
   */
  note: string;
  /**
   *
   * @type {PharmacyPaymentMethod}
   * @memberof PharmacyPharmacy
   */
  onlinePaymentMethod?: PharmacyPaymentMethod;
  /**
   *
   * @type {Array<PharmacyOptionalParameter>}
   * @memberof PharmacyPharmacy
   */
  optionalParameters?: Array<PharmacyOptionalParameter>;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacy
   */
  ownInterviewUrl?: string;
  /**
   *
   * @type {PharmacyPaymentMethod}
   * @memberof PharmacyPharmacy
   */
  paymentMethod?: PharmacyPaymentMethod;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacy
   */
  postalCode: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacy
   */
  prefCode?: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacy
   */
  prescriptionReadingMode?: PharmacyPharmacyPrescriptionReadingModeEnum;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacy
   */
  printerIp?: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacy
   */
  printerPaperType?: PharmacyPharmacyPrinterPaperTypeEnum;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacy
   */
  printerType: PharmacyPharmacyPrinterTypeEnum;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacy
   */
  recommendation?: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacy
   */
  secondExternalId?: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacy
   */
  sendFollowUpMessage?: PharmacyPharmacySendFollowUpMessageEnum;
  /**
   *
   * @type {number}
   * @memberof PharmacyPharmacy
   */
  talkroomExpireDays: number;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacy
   */
  tel: string;
  /**
   *
   * @type {PharmacyTokushoho}
   * @memberof PharmacyPharmacy
   */
  tokushoho?: PharmacyTokushoho;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  usableAcceptCode?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  usableAiocr?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  usableCounselingBoothVoiceAnnouncement?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  usableCounselingSlotQuota?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  usableCrowdStatus?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  usableDigitalPrescription?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  usableDispensingFeature?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  usableDispensingType?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  usableExternalAiAssistant?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  usableMynaHomeWeb?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  usableOcrPrescription?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  usableOnlineCounselingAutoAccepted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  usableOnlineMedicationGuidance?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  usablePrescriptionInquiry?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  usableScanPrescription?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  usableSkipUnluckyNumbers?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  usableTouchReception?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  usableVoiceAnnouncement?: boolean;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacy
   */
  visibility: PharmacyPharmacyVisibilityEnum;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  wantsEmailNotification?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  wantsFaxCounselingRequestedRemind?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacy
   */
  wantsFaxNotification?: boolean;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyPharmacy
   */
  readonly __typename?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PharmacyPharmacyAiOcrRecognitionModeEnum {
  Quality = "quality",
  Speed = "speed",
} /**
 * @export
 * @enum {string}
 */
export enum PharmacyPharmacyCalendarTypeEnum {
  Gregorian = "gregorian",
  Japanese = "japanese",
} /**
 * @export
 * @enum {string}
 */
export enum PharmacyPharmacyPrescriptionReadingModeEnum {
  QrOnly = "qr_only",
  AiOcrOnly = "ai_ocr_only",
  QrOcr = "qr_ocr",
} /**
 * @export
 * @enum {string}
 */
export enum PharmacyPharmacyPrinterPaperTypeEnum {
  Roll58 = "roll58",
  Roll80 = "roll80",
} /**
 * @export
 * @enum {string}
 */
export enum PharmacyPharmacyPrinterTypeEnum {
  Default = "default",
  StarM = "star_m",
  StarMLan = "star_m_lan",
  CitizenLan = "citizen_lan",
} /**
 * @export
 * @enum {string}
 */
export enum PharmacyPharmacySendFollowUpMessageEnum {
  None = "none",
  Auto = "auto",
  Manual = "manual",
} /**
 * @export
 * @enum {string}
 */
export enum PharmacyPharmacyVisibilityEnum {
  Public = "public",
  Private = "private",
  Limited = "limited",
}

export function PharmacyPharmacyFromJSON(json: any): PharmacyPharmacy {
  return PharmacyPharmacyFromJSONTyped(json, false);
}

export function PharmacyPharmacyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PharmacyPharmacy {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyPharmacyTypename,

    additionalHoursText: !exists(json, "additional_hours_text") ? undefined : json["additional_hours_text"],
    address: json["address"],
    aiOcrRecognitionMode: !exists(json, "ai_ocr_recognition_mode") ? undefined : json["ai_ocr_recognition_mode"],
    calendarType: json["calendar_type"],
    calendars: !exists(json, "calendars") ? undefined : (json["calendars"] as Array<any>).map(PharmacyCalendarFromJSON),
    chainAppName: !exists(json, "chain_app_name") ? undefined : json["chain_app_name"],
    chainFqdn: !exists(json, "chain_fqdn") ? undefined : json["chain_fqdn"],
    chainId: !exists(json, "chain_id") ? undefined : json["chain_id"],
    chainIsExceededFollowUpCharLimit: !exists(json, "chain_is_exceeded_follow_up_char_limit")
      ? undefined
      : json["chain_is_exceeded_follow_up_char_limit"],
    chainName: !exists(json, "chain_name") ? undefined : json["chain_name"],
    chainRequiredChildWeight: !exists(json, "chain_required_child_weight")
      ? undefined
      : json["chain_required_child_weight"],
    chainRequiredDateOfBirth: !exists(json, "chain_required_date_of_birth")
      ? undefined
      : json["chain_required_date_of_birth"],
    chainUsableChainFollowUp: !exists(json, "chain_usable_chain_follow_up")
      ? undefined
      : json["chain_usable_chain_follow_up"],
    chainUsableChildWeight: !exists(json, "chain_usable_child_weight") ? undefined : json["chain_usable_child_weight"],
    chainUsableElapsedTime: !exists(json, "chain_usable_elapsed_time") ? undefined : json["chain_usable_elapsed_time"],
    chainUsableMedicineNotebook: !exists(json, "chain_usable_medicine_notebook")
      ? undefined
      : json["chain_usable_medicine_notebook"],
    chainUsableRefill: !exists(json, "chain_usable_refill") ? undefined : json["chain_usable_refill"],
    chainUsableReserverType: !exists(json, "chain_usable_reserver_type")
      ? undefined
      : json["chain_usable_reserver_type"],
    chainUsableUnsupportedList: !exists(json, "chain_usable_unsupported_list")
      ? undefined
      : json["chain_usable_unsupported_list"],
    chainUsableWaitingLabel: !exists(json, "chain_usable_waiting_label")
      ? undefined
      : json["chain_usable_waiting_label"],
    cityCode: !exists(json, "city_code") ? undefined : json["city_code"],
    closedDays: json["closed_days"],
    counselingBoothCount: !exists(json, "counseling_booth_count") ? undefined : json["counseling_booth_count"],
    counselingBoothName: !exists(json, "counseling_booth_name") ? undefined : json["counseling_booth_name"],
    counselingReceptionHours: !exists(json, "counseling_reception_hours")
      ? undefined
      : PharmacyPharmacyHoursFromJSON(json["counseling_reception_hours"]),
    counselingRecurringCalendars: !exists(json, "counseling_recurring_calendars")
      ? undefined
      : (json["counseling_recurring_calendars"] as Array<any>).map(PharmacyRecurringCalendarFromJSON),
    counselingSlotMinutes: !exists(json, "counseling_slot_minutes") ? undefined : json["counseling_slot_minutes"],
    createTalkroom: !exists(json, "create_talkroom") ? undefined : json["create_talkroom"],
    crowdStatusSetting: !exists(json, "crowd_status_setting")
      ? undefined
      : PharmacyPharmacyCrowdStatusSettingFromJSON(json["crowd_status_setting"]),
    currentInformation: PharmacyCurrentInformationFromJSON(json["current_information"]),
    currentInformations: PharmacyCurrentInformationsFromJSON(json["current_informations"]),
    deliveryPostalAreas: !exists(json, "delivery_postal_areas")
      ? undefined
      : (json["delivery_postal_areas"] as Array<any>).map(PharmacyDeliveryPostalAreaFromJSON),
    deliverySetting: !exists(json, "delivery_setting")
      ? undefined
      : PharmacyPharmacyDeliverySettingsFromJSON(json["delivery_setting"]),
    disableCounselingSlotUnspecified: !exists(json, "disable_counseling_slot_unspecified")
      ? undefined
      : json["disable_counseling_slot_unspecified"],
    dispensingCounters: !exists(json, "dispensing_counters") ? undefined : json["dispensing_counters"],
    dispensingReceptionHours: !exists(json, "dispensing_reception_hours")
      ? undefined
      : PharmacyPharmacyHoursFromJSON(json["dispensing_reception_hours"]),
    dispensingRecurringCalendars: !exists(json, "dispensing_recurring_calendars")
      ? undefined
      : (json["dispensing_recurring_calendars"] as Array<any>).map(PharmacyRecurringCalendarFromJSON),
    email: json["email"],
    externalAiAssistantScope: !exists(json, "external_ai_assistant_scope")
      ? undefined
      : (json["external_ai_assistant_scope"] as Array<any>).map(PharmacyExternalAIAssistantScopeFromJSON),
    externalId: !exists(json, "external_id") ? undefined : json["external_id"],
    fax: json["fax"],
    faxPrescriptionWithImage: !exists(json, "fax_prescription_with_image")
      ? undefined
      : json["fax_prescription_with_image"],
    filteredDeliveryPostalAreas: !exists(json, "filtered_delivery_postal_areas")
      ? undefined
      : (json["filtered_delivery_postal_areas"] as Array<any>).map(PharmacyDeliveryPostalAreaFromJSON),
    groupId: !exists(json, "group_id") ? undefined : json["group_id"],
    hasLineOfficialAccount: !exists(json, "has_line_official_account") ? undefined : json["has_line_official_account"],
    id: json["id"],
    ignorePublicHoliday: !exists(json, "ignore_public_holiday") ? undefined : json["ignore_public_holiday"],
    institutionCode: json["institution_code"],
    isCounselingReceptionUntilClosing: !exists(json, "is_counseling_reception_until_closing")
      ? undefined
      : json["is_counseling_reception_until_closing"],
    isCredit: !exists(json, "is_credit") ? undefined : json["is_credit"],
    isDelivery: !exists(json, "is_delivery") ? undefined : json["is_delivery"],
    isDispensing: !exists(json, "is_dispensing") ? undefined : json["is_dispensing"],
    isDisplayVisitWithinOneHour: !exists(json, "is_display_visit_within_one_hour")
      ? undefined
      : json["is_display_visit_within_one_hour"],
    isElectronicMoney: !exists(json, "is_electronic_money") ? undefined : json["is_electronic_money"],
    isFollowUpOnly: !exists(json, "is_follow_up_only") ? undefined : json["is_follow_up_only"],
    isMobileOrderQrCodeEnlarged: !exists(json, "is_mobile_order_qr_code_enlarged")
      ? undefined
      : json["is_mobile_order_qr_code_enlarged"],
    isOnline: !exists(json, "is_online") ? undefined : json["is_online"],
    isOnlinePayment: !exists(json, "is_online_payment") ? undefined : json["is_online_payment"],
    isOpenToday: !exists(json, "is_open_today") ? undefined : json["is_open_today"],
    isParking: !exists(json, "is_parking") ? undefined : json["is_parking"],
    isPrescription: !exists(json, "is_prescription") ? undefined : json["is_prescription"],
    isQrPayment: !exists(json, "is_qr_payment") ? undefined : json["is_qr_payment"],
    isSameDayDelivery: !exists(json, "is_same_day_delivery") ? undefined : json["is_same_day_delivery"],
    isScreening: !exists(json, "is_screening") ? undefined : json["is_screening"],
    isTell: !exists(json, "is_tell") ? undefined : json["is_tell"],
    latitude: json["latitude"] == "" ? undefined : json["latitude"],
    lineInterviewUrl: !exists(json, "line_interview_url") ? undefined : json["line_interview_url"],
    listImage: !exists(json, "list_image")
      ? undefined
      : (json["list_image"] as Array<any>).map(PharmacyPharmacyListImageFromJSON),
    logoImageUrl: !exists(json, "logo_image_url") ? undefined : json["logo_image_url"],
    longitude: json["longitude"] == "" ? undefined : json["longitude"],
    meritTag: !exists(json, "merit_tag") ? undefined : PharmacyMeritTagsFromJSON(json["merit_tag"]),
    minIntegratedCounselingIntervalMinutes: !exists(json, "min_integrated_counseling_interval_minutes")
      ? undefined
      : json["min_integrated_counseling_interval_minutes"],
    mobileOrderCallingScreenMessages: !exists(json, "mobile_order_calling_screen_messages")
      ? undefined
      : (json["mobile_order_calling_screen_messages"] as Array<any>).map(
          PharmacyMobileOrderCallingScreenMessageFromJSON
        ),
    mynaHomeWebUrl: !exists(json, "myna_home_web_url") ? undefined : json["myna_home_web_url"],
    name: json["name"],
    nearestStation: PharmacyPharmacyStationsFromJSON(json["nearest_station"]),
    note: json["note"],
    onlinePaymentMethod: !exists(json, "online_payment_method")
      ? undefined
      : PharmacyPaymentMethodFromJSON(json["online_payment_method"]),
    optionalParameters: !exists(json, "optional_parameters")
      ? undefined
      : (json["optional_parameters"] as Array<any>).map(PharmacyOptionalParameterFromJSON),
    ownInterviewUrl: !exists(json, "own_interview_url") ? undefined : json["own_interview_url"],
    paymentMethod: !exists(json, "payment_method") ? undefined : PharmacyPaymentMethodFromJSON(json["payment_method"]),
    postalCode: json["postal_code"],
    prefCode: !exists(json, "pref_code") ? undefined : json["pref_code"],
    prescriptionReadingMode: !exists(json, "prescription_reading_mode") ? undefined : json["prescription_reading_mode"],
    printerIp: !exists(json, "printer_ip") ? undefined : json["printer_ip"],
    printerPaperType: !exists(json, "printer_paper_type") ? undefined : json["printer_paper_type"],
    printerType: json["printer_type"],
    recommendation: !exists(json, "recommendation") ? undefined : json["recommendation"],
    secondExternalId: !exists(json, "second_external_id") ? undefined : json["second_external_id"],
    sendFollowUpMessage: !exists(json, "send_follow_up_message") ? undefined : json["send_follow_up_message"],
    talkroomExpireDays: json["talkroom_expire_days"],
    tel: json["tel"],
    tokushoho: !exists(json, "tokushoho") ? undefined : PharmacyTokushohoFromJSON(json["tokushoho"]),
    usableAcceptCode: !exists(json, "usable_accept_code") ? undefined : json["usable_accept_code"],
    usableAiocr: !exists(json, "usable_aiocr") ? undefined : json["usable_aiocr"],
    usableCounselingBoothVoiceAnnouncement: !exists(json, "usable_counseling_booth_voice_announcement")
      ? undefined
      : json["usable_counseling_booth_voice_announcement"],
    usableCounselingSlotQuota: !exists(json, "usable_counseling_slot_quota")
      ? undefined
      : json["usable_counseling_slot_quota"],
    usableCrowdStatus: !exists(json, "usable_crowd_status") ? undefined : json["usable_crowd_status"],
    usableDigitalPrescription: !exists(json, "usable_digital_prescription")
      ? undefined
      : json["usable_digital_prescription"],
    usableDispensingFeature: !exists(json, "usable_dispensing_feature") ? undefined : json["usable_dispensing_feature"],
    usableDispensingType: !exists(json, "usable_dispensing_type") ? undefined : json["usable_dispensing_type"],
    usableExternalAiAssistant: !exists(json, "usable_external_ai_assistant")
      ? undefined
      : json["usable_external_ai_assistant"],
    usableMynaHomeWeb: !exists(json, "usable_myna_home_web") ? undefined : json["usable_myna_home_web"],
    usableOcrPrescription: !exists(json, "usable_ocr_prescription") ? undefined : json["usable_ocr_prescription"],
    usableOnlineCounselingAutoAccepted: !exists(json, "usable_online_counseling_auto_accepted")
      ? undefined
      : json["usable_online_counseling_auto_accepted"],
    usableOnlineMedicationGuidance: !exists(json, "usable_online_medication_guidance")
      ? undefined
      : json["usable_online_medication_guidance"],
    usablePrescriptionInquiry: !exists(json, "usable_prescription_inquiry")
      ? undefined
      : json["usable_prescription_inquiry"],
    usableScanPrescription: !exists(json, "usable_scan_prescription") ? undefined : json["usable_scan_prescription"],
    usableSkipUnluckyNumbers: !exists(json, "usable_skip_unlucky_numbers")
      ? undefined
      : json["usable_skip_unlucky_numbers"],
    usableTouchReception: !exists(json, "usable_touch_reception") ? undefined : json["usable_touch_reception"],
    usableVoiceAnnouncement: !exists(json, "usable_voice_announcement") ? undefined : json["usable_voice_announcement"],
    visibility: json["visibility"],
    wantsEmailNotification: !exists(json, "wants_email_notification") ? undefined : json["wants_email_notification"],
    wantsFaxCounselingRequestedRemind: !exists(json, "wants_fax_counseling_requested_remind")
      ? undefined
      : json["wants_fax_counseling_requested_remind"],
    wantsFaxNotification: !exists(json, "wants_fax_notification") ? undefined : json["wants_fax_notification"],
  };
}

export function PharmacyPharmacyToJSON(object?: PharmacyPharmacy | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    additional_hours_text: value.additionalHoursText,
    address: value.address,
    ai_ocr_recognition_mode: value.aiOcrRecognitionMode,
    calendar_type: value.calendarType,
    calendars: value.calendars === undefined ? undefined : (value.calendars as Array<any>).map(PharmacyCalendarToJSON),
    chain_app_name: value.chainAppName,
    chain_fqdn: value.chainFqdn,
    chain_id: value.chainId,
    chain_is_exceeded_follow_up_char_limit: value.chainIsExceededFollowUpCharLimit,
    chain_name: value.chainName,
    chain_required_child_weight: value.chainRequiredChildWeight,
    chain_required_date_of_birth: value.chainRequiredDateOfBirth,
    chain_usable_chain_follow_up: value.chainUsableChainFollowUp,
    chain_usable_child_weight: value.chainUsableChildWeight,
    chain_usable_elapsed_time: value.chainUsableElapsedTime,
    chain_usable_medicine_notebook: value.chainUsableMedicineNotebook,
    chain_usable_refill: value.chainUsableRefill,
    chain_usable_reserver_type: value.chainUsableReserverType,
    chain_usable_unsupported_list: value.chainUsableUnsupportedList,
    chain_usable_waiting_label: value.chainUsableWaitingLabel,
    city_code: value.cityCode,
    closed_days: value.closedDays,
    counseling_booth_count: value.counselingBoothCount,
    counseling_booth_name: value.counselingBoothName,
    counseling_reception_hours: PharmacyPharmacyHoursToJSON(value.counselingReceptionHours),
    counseling_recurring_calendars:
      value.counselingRecurringCalendars === undefined
        ? undefined
        : (value.counselingRecurringCalendars as Array<any>).map(PharmacyRecurringCalendarToJSON),
    counseling_slot_minutes: value.counselingSlotMinutes,
    create_talkroom: value.createTalkroom,
    crowd_status_setting: PharmacyPharmacyCrowdStatusSettingToJSON(value.crowdStatusSetting),
    current_information: PharmacyCurrentInformationToJSON(value.currentInformation),
    current_informations: PharmacyCurrentInformationsToJSON(value.currentInformations),
    delivery_postal_areas:
      value.deliveryPostalAreas === undefined
        ? undefined
        : (value.deliveryPostalAreas as Array<any>).map(PharmacyDeliveryPostalAreaToJSON),
    delivery_setting: PharmacyPharmacyDeliverySettingsToJSON(value.deliverySetting),
    disable_counseling_slot_unspecified: value.disableCounselingSlotUnspecified,
    dispensing_counters: value.dispensingCounters,
    dispensing_reception_hours: PharmacyPharmacyHoursToJSON(value.dispensingReceptionHours),
    dispensing_recurring_calendars:
      value.dispensingRecurringCalendars === undefined
        ? undefined
        : (value.dispensingRecurringCalendars as Array<any>).map(PharmacyRecurringCalendarToJSON),
    email: value.email,
    external_ai_assistant_scope:
      value.externalAiAssistantScope === undefined
        ? undefined
        : (value.externalAiAssistantScope as Array<any>).map(PharmacyExternalAIAssistantScopeToJSON),
    external_id: value.externalId,
    fax: value.fax,
    fax_prescription_with_image: value.faxPrescriptionWithImage,
    filtered_delivery_postal_areas:
      value.filteredDeliveryPostalAreas === undefined
        ? undefined
        : (value.filteredDeliveryPostalAreas as Array<any>).map(PharmacyDeliveryPostalAreaToJSON),
    group_id: value.groupId,
    has_line_official_account: value.hasLineOfficialAccount,
    id: value.id,
    ignore_public_holiday: value.ignorePublicHoliday,
    institution_code: value.institutionCode,
    is_counseling_reception_until_closing: value.isCounselingReceptionUntilClosing,
    is_credit: value.isCredit,
    is_delivery: value.isDelivery,
    is_dispensing: value.isDispensing,
    is_display_visit_within_one_hour: value.isDisplayVisitWithinOneHour,
    is_electronic_money: value.isElectronicMoney,
    is_follow_up_only: value.isFollowUpOnly,
    is_mobile_order_qr_code_enlarged: value.isMobileOrderQrCodeEnlarged,
    is_online: value.isOnline,
    is_online_payment: value.isOnlinePayment,
    is_open_today: value.isOpenToday,
    is_parking: value.isParking,
    is_prescription: value.isPrescription,
    is_qr_payment: value.isQrPayment,
    is_same_day_delivery: value.isSameDayDelivery,
    is_screening: value.isScreening,
    is_tell: value.isTell,
    latitude: (value.latitude as unknown as string) == "" ? undefined : value.latitude,
    line_interview_url: value.lineInterviewUrl,
    list_image:
      value.listImage === undefined ? undefined : (value.listImage as Array<any>).map(PharmacyPharmacyListImageToJSON),
    logo_image_url: value.logoImageUrl,
    longitude: (value.longitude as unknown as string) == "" ? undefined : value.longitude,
    merit_tag: PharmacyMeritTagsToJSON(value.meritTag),
    min_integrated_counseling_interval_minutes: value.minIntegratedCounselingIntervalMinutes,
    mobile_order_calling_screen_messages:
      value.mobileOrderCallingScreenMessages === undefined
        ? undefined
        : (value.mobileOrderCallingScreenMessages as Array<any>).map(PharmacyMobileOrderCallingScreenMessageToJSON),
    myna_home_web_url: value.mynaHomeWebUrl,
    name: value.name,
    nearest_station: PharmacyPharmacyStationsToJSON(value.nearestStation),
    note: value.note,
    online_payment_method: PharmacyPaymentMethodToJSON(value.onlinePaymentMethod),
    optional_parameters:
      value.optionalParameters === undefined
        ? undefined
        : (value.optionalParameters as Array<any>).map(PharmacyOptionalParameterToJSON),
    own_interview_url: value.ownInterviewUrl,
    payment_method: PharmacyPaymentMethodToJSON(value.paymentMethod),
    postal_code: value.postalCode,
    pref_code: value.prefCode,
    prescription_reading_mode: value.prescriptionReadingMode,
    printer_ip: value.printerIp,
    printer_paper_type: value.printerPaperType,
    printer_type: value.printerType,
    recommendation: value.recommendation,
    second_external_id: value.secondExternalId,
    send_follow_up_message: value.sendFollowUpMessage,
    talkroom_expire_days: value.talkroomExpireDays,
    tel: value.tel,
    tokushoho: PharmacyTokushohoToJSON(value.tokushoho),
    usable_accept_code: value.usableAcceptCode,
    usable_aiocr: value.usableAiocr,
    usable_counseling_booth_voice_announcement: value.usableCounselingBoothVoiceAnnouncement,
    usable_counseling_slot_quota: value.usableCounselingSlotQuota,
    usable_crowd_status: value.usableCrowdStatus,
    usable_digital_prescription: value.usableDigitalPrescription,
    usable_dispensing_feature: value.usableDispensingFeature,
    usable_dispensing_type: value.usableDispensingType,
    usable_external_ai_assistant: value.usableExternalAiAssistant,
    usable_myna_home_web: value.usableMynaHomeWeb,
    usable_ocr_prescription: value.usableOcrPrescription,
    usable_online_counseling_auto_accepted: value.usableOnlineCounselingAutoAccepted,
    usable_online_medication_guidance: value.usableOnlineMedicationGuidance,
    usable_prescription_inquiry: value.usablePrescriptionInquiry,
    usable_scan_prescription: value.usableScanPrescription,
    usable_skip_unlucky_numbers: value.usableSkipUnluckyNumbers,
    usable_touch_reception: value.usableTouchReception,
    usable_voice_announcement: value.usableVoiceAnnouncement,
    visibility: value.visibility,
    wants_email_notification: value.wantsEmailNotification,
    wants_fax_counseling_requested_remind: value.wantsFaxCounselingRequestedRemind,
    wants_fax_notification: value.wantsFaxNotification,
  };
}
